export default "__VITE_ASSET__1e7c6a52__"